import React, { useState } from "react";
import Modal from "./Modal";

export default function Search({ searchText }) {
  const [openModal, setOpenModal] = useState(false);
  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  return (
    <>
      <button
        className="search all-caps"
        onClick={() => setOpenModal(!openModal)}
        {...(isMobile ? { "aria-label": searchText } : {})}
      >
        {!isMobile && searchText}
      </button>
      <Modal openModal={openModal} setOpenModal={setOpenModal} />
    </>
  );
}
